import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const hasErrors = createTaskFilterFunction('he', (task: TaskListTask, filters: RunbookFilterType): boolean => {
  return filters.he ? task.errors.length > 0 : task.errors.length === 0
})
